var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.214,
    height: 21.214,
    viewBox: "0 0 21.214 21.214",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "upload_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "upload_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M189.547-764.034v-11.88l-3.487,3.487-1.49-1.534L190.608-780l6.038,6.038-1.49,1.534-3.487-3.487v11.88Zm-6.99,5.249a2.468,2.468,0,0,1-1.814-.742,2.468,2.468,0,0,1-.742-1.814v-3.835h2.121v3.835a.416.416,0,0,0,.136.3.416.416,0,0,0,.3.136h16.1a.416.416,0,0,0,.3-.136.416.416,0,0,0,.136-.3v-3.835h2.121v3.835a2.468,2.468,0,0,1-.742,1.814,2.468,2.468,0,0,1-1.814.742Z",
    transform: "translate(-180.001 779.999)",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.500ba4d1c6ac247a29aabbcdb1dfbdeb.svg";
export { ForwardRef as ReactComponent };